module.exports = __webpack_public_path__ + "img/coupon-item-invalid-bg.90a34d18.png";